import { Directive } from '@angular/core';

@Directive({
  selector: '[appMatchPassword]'
})
export class MatchPasswordDirective {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/match-password-directive/match-password.directive.ts